import React, { useState, useEffect  } from 'react';
import Logo from "./components/Logo";
import Social from "./components/Social";
import NavArea from "./components/NavArea";
import AnimatedRoutes from './components/AnimatedRoutes';
import { useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRemove } from '@fortawesome/free-solid-svg-icons';
import ReactGA from "react-ga4";

const TRACKING_ID = "G-W4K8KRS2MX"; // Replace with your Measurement ID
ReactGA.initialize(TRACKING_ID);

function App() {
  const [navAreaClass, setNavAreaClass] = useState('');
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);

  const toggleNavAreaClass = () => {
    const navAreaElement = document.querySelector('.navarea');
    if (navAreaElement && !navAreaElement.classList.contains('animation-running')) {
      if (!navAreaElement.classList.contains('active')) {
        setNavAreaClass('active');
      } else if (navAreaElement.classList.contains('active') && !navAreaElement.classList.contains('not-active')) {
        setNavAreaClass('not-active');
      } else {
        setNavAreaClass('active');
      }
    }

    const bodyElement = document.querySelector('body');
    if (bodyElement && bodyElement.classList.contains('not-homepage') && (navAreaElement && navAreaElement.classList.contains('active'))) {
      bodyElement.classList.remove('not-homepage');
    }
  };

  const navigate = useNavigate();
  const handleCloseClick = () => {
    navigate('/');
  };

  return (
    <div className='site-wrap'>
      <header>
        <Social />
      </header>
      <main>
        <Logo onMustacheClick={toggleNavAreaClass} />
        <div>
          <section className='content'>
            <button onClick={handleCloseClick} className="close-button">
              <span className="sr-only">Close</span>
              <FontAwesomeIcon icon={faRemove} />
            </button>
            <AnimatedRoutes />
          </section>
          <hr />
          <NavArea className={navAreaClass} />
        </div>
      </main>
    </div>
  );
}

export default App;
